import { render, staticRenderFns } from "./famous.vue?vue&type=template&id=11eb9624&scoped=true"
import script from "./famous.vue?vue&type=script&lang=js"
export * from "./famous.vue?vue&type=script&lang=js"
import style0 from "./famous.vue?vue&type=style&index=0&id=11eb9624&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eb9624",
  null
  
)

export default component.exports